import * as React from 'react'

import { Box, Link, ProgressBar, Text } from '@factorialco/deprecated-design-system'
import { DataSchemaItemFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { MappedFields } from 'modules/employees/pages/ImportProcessPage/components/ImportProcessWizard/types'

import MapColumnsSidepanel from './MapColumnsSidepanel'

export interface Props {
  fields: DataSchemaItemFragment[]
  mappedFields: MappedFields[]
  missingFieldNames: string
  isWarning: boolean
}

const MapColumnsInfo = ({ fields, mappedFields, missingFieldNames, isWarning }: Props) => {
  const [isSidepanelOpen, setIsSidepanelOpen] = React.useState(false)

  const handleToggleSidepanel = () => {
    if (!isSidepanelOpen) {
      track(trackingEvents.importEmployees.mapColumnsStep.seeFields)
    }
    setIsSidepanelOpen(!isSidepanelOpen)
  }

  return (
    <Box>
      <Box flexDirection="row" alignItems="baseline" gap="s16" paddingBottom="s16">
        <Box minWidth="s240" flexDirection="row" gap="s4" paddingTop="s16">
          <ProgressBar
            amount={mappedFields.length}
            total={fields.length}
            barColor={isWarning ? 'radicalRed200' : undefined}
            progressColor={isWarning ? 'radicalRed1000' : undefined}
            showLabel
          />
          <Box flexGrow flexNoShrink>
            <Text.Normal size="200">
              {i18n.t('importer_process.map_columns_step.progress_bar.label')}
            </Text.Normal>
          </Box>
        </Box>
        <Link.Touchable onClick={handleToggleSidepanel}>
          {i18n.t('importer_process.map_columns_step.progress_bar.link')}
        </Link.Touchable>
      </Box>
      {isWarning && (
        <Text.Normal color="radicalRed1200">
          {i18n.t('importer_process.map_columns_step.progress_bar.warning_label', {
            fields: missingFieldNames,
          })}
        </Text.Normal>
      )}
      {isSidepanelOpen && (
        <MapColumnsSidepanel
          onClose={handleToggleSidepanel}
          fields={fields}
          mappedFields={mappedFields}
        />
      )}
    </Box>
  )
}

export default MapColumnsInfo
